<template>
	<div class="start-playing">
		<speaker-notes :notes="currentNotes"></speaker-notes>
		<h2>Implementation - Start Playing</h2>
		<flow-chart selected="start"></flow-chart>
		<code :class="`p${part}`">
			// For each of the tracks (that is, one rhythm, one melody)<br>
			function <span class="b1">start</span>(audioBuffer, startWhen, startWhere) {<br>
			&nbsp;&nbsp;// source is of type <span class="b2">AudioBufferSourceNode</span><br>
			&nbsp;&nbsp;// destination is of type <span class="b4">AudioDestinationNode</span><br>
			&nbsp;&nbsp;let source = activeAudioContext().<span class="b2">createBufferSource</span>();<br>
			&nbsp;&nbsp;<span class="b3">source.buffer = audioBuffer;</span><br>
			&nbsp;&nbsp;source.<span class="b4">connect</span>(activeAudioContext().<span class="b4">destination</span>);<br>
			&nbsp;&nbsp;source.<span class="b5">start</span>(startWhen, startWhere);<br>
			}<br>
			<br>
			<span class="b6">startAnimationTimer</span>(); // requestAnimationFrame
		</code>
	</div>
</template>

<script>
	import PageParts from "../helpers/page-parts";
	import FlowChart from "../components/FlowChart";
	import SpeakerNotes from "../components/SpeakerNotes";
	export default {
		name: "start-playing",
		components: {SpeakerNotes, FlowChart},
		mixins: [
			PageParts,
		],
		data() {
			return {
				notes: [
					[
						"For each of the buffers we prepared before (that is, 'tracks').",
					],
					[
						"Create a 'source'.",
						"This is where the audio is coming from.",
						"Need to recreate this for each run, can't pause or reuse them.",
						"Supposedly this is really cheap to do.",
					],
					[
						"Populate the buffer.",
						"This buffer is what we just created by hand.",
						"The original one can be reused for pausing or random access."
					],
					[
						"Connect the source to the audio context's destination.",
						"The source is what we just created.",
						"The destination is whatever speakers are selected.",
						"Between these two is where you can insert a bunch of effects.",
					],
					[
						"For each of the tracks that we've set up, we start it.",
						"You can tell it when to start. Zero is right away.",
						"You can also tell it the offset to start at.",
						"For pause/resume and clicking on the progress control",
					],
					[
						"Then start an animation timer to take care of callbacks.",
						"This has nothing to do with the audio system, it is just a regular timer.",
						"You definitely need a callback to move the little progress on the audio control.",
						"and change the clock. It is likely that you'll have some other things to control."
					],
				]
			};
		},
	};
</script>

<style lang="scss" scoped>
	.start-playing {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	code {
		margin-top: 20px;
	}
</style>
